import React from "react";
import { useNavigate } from "react-router-dom";

const UnauthorizedPage = () => {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  return (
    <main className="h-screen w-full bg-white">
      <section className="w-full h-full flex flex-col justify-start items-center pt-20">
        <h1 className="text-xl">Unauthorized Account</h1>
        <p className="font-rom">
          Please contact main admin for further information.
        </p>
        <p onClick={goBack} className="mt-2 cursor-pointer hover:text-primary">
          Go back!
        </p>
      </section>
    </main>
  );
};

export default UnauthorizedPage;
